import React from "react";
import Grid from "@material-ui/core/Grid";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import TeamSummary from "./TeamSummary";
import GameOverall from "./GameOverall";
import { useGameContextContext } from "../../../state/game-context/context";
import { useTeamsContext } from "../../../state/teams/context";
import gameSummaryStyles from "../styles/GameSummary.styles";

const GameSummary = ({ size, preview = false }) => {
	const classes = gameSummaryStyles();
	const xsScreen = useMediaQuery((theme) => theme.breakpoints.down("xs"));

	const { state: teamState } = useTeamsContext();
	const homeTeam = teamState.homeTeam();
	const visitorTeam = teamState.awayTeam();

	const { state } = useGameContextContext();
	const homeScore = state.homeScore();
	const visitorScore = state.visitorScore();
	const homeTeamHasPossession = state.homeTeamHasPossession();
	const homeTimeouts = state.homeTimeouts();
	const visitorTimeouts = state.visitorTimeouts();
	const swapTeams = state.swapTeams();

	return (
		<Grid
			container
			justifyContent="space-between"
			alignItems="center"
			direction={swapTeams ? "row-reverse" : "row"}
			spacing={2}
		>
			{xsScreen && (
				<Grid item xs={12}>
					<GameOverall size="small" preview={preview} />
				</Grid>
			)}
			<Grid item xs={xsScreen ? 6 : 4} className={classes.teamSummary}>
				<TeamSummary
					team={visitorTeam}
					reversed={!swapTeams}
					hasPossession={!homeTeamHasPossession}
					score={visitorScore}
					timeouts={visitorTimeouts}
					size={size}
				/>
			</Grid>
			{!xsScreen && (
				<Grid item xs={4}>
					<GameOverall size={size} preview={preview} />
				</Grid>
			)}
			<Grid item xs={xsScreen ? 6 : 4} className={classes.teamSummary}>
				<TeamSummary
					team={homeTeam}
					reversed={swapTeams}
					hasPossession={homeTeamHasPossession}
					score={homeScore}
					timeouts={homeTimeouts}
					size={size}
				/>
			</Grid>
		</Grid>
	);
};

export default GameSummary;
